import React from "react";

import "./askcollabria.css";

export const AskCollabria = ({}) => {
    return <button className="ask-button">Ask Collabria!</button>;
};
